import { Component } from '@angular/core';

@Component({
    selector: 'pgf-pie',
    templateUrl: `./pie.component.html`,
    styleUrls: ['./pie.component.scss']
})

export class PgfPieComponent {
  public hovered_area = '';

  hoverArea(n:number) {
    this.hovered_area = n>0? 'pie-section-'+n : '';
  }
}